module.exports = __webpack_public_path__ + "img/50.996576d8.png";